import {
  RecentlyDeletedTableCell,
  type RecentlyDeletedTableCellProps,
} from '~/components/RecentlyDeleted/components/RecentlyDeletedTableCell';
import { getTableColumnWidth } from '~/components/RecentlyDeleted/utils/getTableColumnWidth';

export type RecentlyDeletedTableCellActionProps = Pick<RecentlyDeletedTableCellProps, 'children'>;

export const RecentlyDeletedTableCellAction = ({ children }: RecentlyDeletedTableCellActionProps) => (
  <RecentlyDeletedTableCell className="!py-0" width={getTableColumnWidth('action')}>
    {children}
  </RecentlyDeletedTableCell>
);
